import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useLayoutEffect, useRef } from 'react';
import cx from 'clsx';
import { useClickOutside } from '@hooks';
import { HexColorPicker, HexColorInput } from 'react-colorful';
import { useTheme } from '../../ThemeProvider';
import classes from './HexInput.styles.less';
export default function HexInput({ className, value, onChange, ...others }) {
    const [theme] = useTheme();
    const ref = useRef(null);
    const [opened, setOpened] = useState(false);
    const closePicker = () => setOpened(false);
    const closeOnEscape = (event) => event.code === 'Escape' && closePicker();
    useClickOutside(ref, closePicker);
    useLayoutEffect(() => {
        window.addEventListener('keydown', closeOnEscape);
        return () => window.removeEventListener('keydown', closeOnEscape);
    }, []);
    return (_jsxs("div", { className: cx(classes.wrapper, classes[theme], className), ref: ref, children: [_jsxs("div", { className: classes.inputWrapper, children: [_jsx("button", { className: classes.control, type: "button", onClick: () => setOpened((o) => !o), style: { backgroundColor: value } }), _jsx("div", { className: classes.hash, children: "#" }), _jsx(HexColorInput, { ...others, className: classes.input, color: value, onChange: onChange })] }), opened && _jsx(HexColorPicker, { className: classes.picker, color: value, onChange: onChange })] }));
}
